import React from 'react';
import { graphql } from 'gatsby';
import { DiscussionEmbed } from 'disqus-react';
import Moment from "moment";
import Seo from "../components/seo";

import Sidebar from '../components/sidebar';
import Layout from "../components/layout"

export default function Template({data}) {
  const { markdownRemark } = data;
  const { frontmatter, html } = markdownRemark;
  const disqusShortname = 'papadkostas';
  const disqusConfig = { identifier: frontmatter.title, title: frontmatter.title };
  const date = Moment(new Date(frontmatter.date)).format('Do MMM YYYY');

  return(
    <Layout>
      <div>
        <Seo title={frontmatter.title} />
          <div className="flex flex-wrap flex-col-reverse lg:flex-row flex-col-reverse">
            <div className="w-full lg:w-3/12">
                <Sidebar></Sidebar>
            </div>
            <div className="blog-post w-full lg:w-9/12 lg:pl-20 mb-4">
              <h1 className="blog-title text-4xl font-bold tracking-tighter mb-4">{frontmatter.title}</h1>
              <div className="blog-post-time mb-4 italic">Posted on <time>{date}</time></div>
              <div className="blog-post-content mb-4" dangerouslySetInnerHTML={{ __html: html }} />
              <DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
            </div>
          </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        date
      }
    }
  }
`